(() => {
  'use strict';

  const w = window;
  const d = document;
  const root = d.documentElement;
  const contextNode = d.getElementById('KloudzOrbitContext');
  const command = d.querySelector('[data-ko-command]');
  const commandInput = d.querySelector('[data-ko-command-input]');
  if (!contextNode || !command || !commandInput || root.dataset.koBound === 'true') return;

  // Halo's retired menu loader still runs from theme.min.js and assumes the
  // replaced navigation nodes exist. Keep its internal initialization safe
  // without rendering or reviving the legacy header.
  let legacyHeader = d.querySelector('.header-nav');
  if (!legacyHeader) {
    legacyHeader = d.createElement('div');
    legacyHeader.className = 'header-nav ko-legacy-header-bridge';
    legacyHeader.hidden = true;
    legacyHeader.setAttribute('aria-hidden', 'true');
    d.body.appendChild(legacyHeader);
  }
  if (!legacyHeader.dataset.urlStyleMenu) legacyHeader.dataset.urlStyleMenu = '';
  if (!d.getElementById('HeaderNavigation')) {
    const legacyNavigation = d.createElement('nav');
    legacyNavigation.id = 'HeaderNavigation';
    legacyHeader.appendChild(legacyNavigation);
  }

  let context;
  try { context = JSON.parse(contextNode.textContent || '{}'); } catch (_) { return; }
  root.dataset.koBound = 'true';
  root.dataset.koPage = String(context.pageType || 'unknown').replace(/[^a-z0-9_-]/gi, '').toLowerCase();

  const VERSION = '1.0.0';
  const SAVED_KEY = 'kloudz_orbit_saved_1';
  const $ = (selector, scope = d) => scope.querySelector(selector);
  const $$ = (selector, scope = d) => [...scope.querySelectorAll(selector)];
  const clean = (value, max = 160) => String(value == null ? '' : value)
    .replace(/[<>\u0000-\u001f]/g, '').replace(/\s+/g, ' ').trim().slice(0, max);
  const escapeSelector = (value) => {
    try { return w.CSS.escape(String(value)); } catch (_) { return String(value).replace(/[^a-z0-9_-]/gi, ''); }
  };
  const route = (name, fallback) => {
    const value = String(context.routes?.[name] || fallback || '/');
    return value.startsWith('/') ? value : fallback;
  };
  const searchRoute = route('search', '/search');
  const collectionsRoute = route('collections', '/collections');
  const live = $('[data-ko-live]');
  const network = $('[data-ko-network]');
  const decision = $('[data-ko-decision]');
  const commandTrigger = $('[data-ko-command-open]');
  const nativeNavigator = $('[aria-label*="Open Kloudz catalog navigator"], [data-klz-command-open], [data-klz-launch]');
  if (nativeNavigator && commandTrigger) {
    root.dataset.koNativeNavigator = 'true';
    commandTrigger.hidden = true;
    commandTrigger.setAttribute('aria-hidden', 'true');
  }
  let previousFocus = null;
  let searchTimer = 0;
  let observerTimer = 0;
  let toastTimer = 0;

  const safeStore = (store) => {
    try {
      const probe = '__ko_probe__';
      store.setItem(probe, '1');
      store.removeItem(probe);
      return store;
    } catch (_) { return null; }
  };
  const sessionStore = safeStore(w.sessionStorage);
  const localStore = safeStore(w.localStorage);
  const privacyAPI = () => w.Shopify && w.Shopify.customerPrivacy;
  const privacyAllowed = (name) => {
    try {
      const api = privacyAPI();
      return Boolean(api && typeof api[name] === 'function' && api[name]());
    } catch (_) { return false; }
  };
  const preferenceStore = () => (privacyAllowed('preferencesProcessingAllowed') && localStore) || sessionStore;
  const intelligenceConfig = (() => {
    try { return JSON.parse(d.getElementById('KloudzIntelligenceConfig')?.textContent || '{}'); } catch (_) { return {}; }
  })();

  function emit(name, payload = {}) {
    if (!intelligenceConfig.telemetry || !privacyAllowed('analyticsProcessingAllowed')) return;
    if (!w.KloudzIntelligence || typeof w.KloudzIntelligence.event !== 'function') return;
    try { w.KloudzIntelligence.event(name, { orbit: VERSION, pageType: context.pageType, ...payload }); } catch (_) {}
  }

  function announce(message) {
    if (!live) return;
    live.textContent = '';
    w.setTimeout(() => { live.textContent = clean(message, 220); }, 20);
  }

  function toast(message) {
    let node = $('.ko-toast');
    if (!node) {
      node = d.createElement('div');
      node.className = 'ko-toast';
      node.setAttribute('role', 'status');
      d.body.appendChild(node);
    }
    node.textContent = clean(message, 180);
    node.dataset.koShow = 'true';
    w.clearTimeout(toastTimer);
    toastTimer = w.setTimeout(() => { node.dataset.koShow = 'false'; }, 2600);
    announce(message);
  }

  function readSaved() {
    try {
      const parsed = JSON.parse(preferenceStore()?.getItem(SAVED_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && String(item.url || '').startsWith('/')).slice(0, 12) : [];
    } catch (_) { return []; }
  }

  function writeSaved(items) {
    try { preferenceStore()?.setItem(SAVED_KEY, JSON.stringify(items.slice(0, 12))); } catch (_) {}
    renderSaved();
    try { orbitChannel?.postMessage({ type: 'saved' }); } catch (_) {}
  }

  function currentProduct() {
    if (!context.product) return null;
    const url = String(context.product.url || '');
    if (!url.startsWith('/')) return null;
    return {
      handle: clean(context.product.handle, 90),
      price: clean(context.product.price, 40),
      title: clean(context.product.title, 140),
      url,
      at: Date.now()
    };
  }

  function isSaved(url) { return readSaved().some((item) => item.url === url); }

  function toggleSaved(product) {
    if (!product) return false;
    const items = readSaved();
    const index = items.findIndex((item) => item.url === product.url);
    if (index >= 0) items.splice(index, 1);
    else items.unshift(product);
    writeSaved(items);
    const saved = index < 0;
    emit(saved ? 'orbit_product_saved' : 'orbit_product_unsaved', { handle: product.handle });
    toast(saved ? 'Saved for later.' : 'Removed from saved items.');
    return saved;
  }

  function renderSaved() {
    const section = $('[data-ko-saved-section]');
    const list = $('[data-ko-saved-list]');
    if (!section || !list) return;
    const items = readSaved();
    section.hidden = !items.length;
    list.replaceChildren();
    items.slice(0, 6).forEach((item) => {
      const link = d.createElement('a');
      link.href = item.url;
      const wrap = d.createElement('span');
      const title = d.createElement('strong');
      const price = d.createElement('small');
      title.textContent = clean(item.title, 100) || 'Saved product';
      price.textContent = clean(item.price, 32) || 'View product';
      wrap.append(title, price);
      const arrow = d.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      link.append(wrap, arrow);
      list.appendChild(link);
    });
  }

  function openAssistant(prompt) {
    closeCommand(false);
    const launcher = $('[data-kra-launch]');
    if (!launcher) {
      toast('Kloudz guidance is reconnecting. Please try again in a moment.');
      return;
    }
    if (w.KloudzRelationshipAssistant && typeof w.KloudzRelationshipAssistant.open === 'function') {
      w.KloudzRelationshipAssistant.open();
    } else launcher.click();
    const input = $('[data-kra-input]');
    if (input && prompt) {
      input.value = clean(prompt, 400);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
      announce('A suggested question is ready. Review it before sending.');
    }
  }

  function focusableInCommand() {
    return $$('a[href], button:not([disabled]), input:not([disabled])', command)
      .filter((node) => !node.hidden && node.offsetParent !== null);
  }

  function openCommand() {
    previousFocus = d.activeElement;
    command.hidden = false;
    command.setAttribute('aria-hidden', 'false');
    root.dataset.koCommandOpen = 'true';
    renderSaved();
    w.setTimeout(() => commandInput.focus(), 40);
    emit('orbit_command_open');
  }

  function closeCommand(restoreFocus = true) {
    if (command.hidden) return;
    command.hidden = true;
    command.setAttribute('aria-hidden', 'true');
    delete root.dataset.koCommandOpen;
    if (restoreFocus && previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  function productFromSuggestion(item) {
    if (!item || typeof item !== 'object') return null;
    const url = String(item.url || (item.handle ? `/products/${item.handle}` : ''));
    if (!url.startsWith('/products/')) return null;
    return {
      price: clean(item.price || item.price_min, 40),
      title: clean(item.title, 120),
      url: url.slice(0, 180)
    };
  }

  async function suggest(query) {
    const section = $('[data-ko-command-results]');
    const list = $('[data-ko-command-results-list]');
    const text = clean(query, 100);
    if (!section || !list || text.length < 2) {
      if (section) section.hidden = true;
      return;
    }
    try {
      const params = new URLSearchParams({
        q: text,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide'
      });
      const response = await fetch(`${searchRoute}/suggest.json?${params}`, {
        headers: { Accept: 'application/json' }, cache: 'no-store'
      });
      if (!response.ok) throw new Error('suggest_failed');
      const body = await response.json();
      const products = (body?.resources?.results?.products || []).map(productFromSuggestion).filter(Boolean).slice(0, 6);
      list.replaceChildren();
      products.forEach((product) => {
        const link = d.createElement('a');
        link.href = product.url;
        const wrap = d.createElement('span');
        const title = d.createElement('strong');
        const price = d.createElement('small');
        title.textContent = product.title;
        price.textContent = product.price || 'View product';
        wrap.append(title, price);
        const arrow = d.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.append(wrap, arrow);
        list.appendChild(link);
      });
      section.hidden = !products.length;
      if (products.length) announce(`${products.length} live product suggestions available.`);
    } catch (_) { section.hidden = true; }
  }

  function findProductTitle(scope) {
    const link = $('a[href*="/products/"]', scope);
    const heading = $('[data-product-title], .card-title, .card__heading, .product-title, .product-item__title, h2, h3', scope);
    return clean(heading?.textContent || link?.getAttribute('title') || link?.textContent, 120);
  }

  function productCardFor(node) {
    return node.closest('[data-product-card], .product-card, .card-product, .product-item, .product, .card') || node.parentElement;
  }

  function repairProductMedia(scope = d) {
    $$('a[href*="/products/"] img, img[src*="/products/"]', scope).forEach((image) => {
      if (image.dataset.koMediaChecked === 'true') return;
      image.dataset.koMediaChecked = 'true';
      image.dataset.koProductImage = 'true';
      const alt = clean(image.getAttribute('alt'), 180);
      const noisy = !alt || /^#/.test(alt) || (alt.match(/#[a-z0-9_]+/gi) || []).length > 2;
      if (!noisy) return;
      const card = productCardFor(image);
      const title = findProductTitle(card || image.parentElement);
      image.alt = title ? `${title} product image` : 'Product image';
    });
  }

  function repairCompareControls(scope = d) {
    const candidates = $$('button, [role="button"]', scope).filter((node) => /add product to comparison/i.test(clean(node.textContent || node.getAttribute('aria-label'), 120)));
    const groups = new Map();
    candidates.forEach((control) => {
      const card = productCardFor(control) || control.parentElement;
      if (!groups.has(card)) groups.set(card, []);
      groups.get(card).push(control);
    });
    groups.forEach((controls, card) => {
      const title = findProductTitle(card);
      controls.forEach((control, index) => {
        if (index > 0) {
          control.dataset.koHiddenDuplicate = 'true';
          control.setAttribute('aria-hidden', 'true');
          control.tabIndex = -1;
        } else {
          control.setAttribute('aria-label', title ? `Compare ${title}` : 'Compare product');
          control.removeAttribute('title');
        }
      });
    });
  }

  function repairRatings(scope = d) {
    $$('[class*="rating"], .spr-badge', scope).forEach((rating) => {
      if (rating.dataset.koRatingChecked === 'true') return;
      rating.dataset.koRatingChecked = 'true';
      const text = clean(rating.textContent, 100);
      const explicit = clean(rating.getAttribute('aria-label') || rating.getAttribute('data-rating') || rating.getAttribute('title'), 100);
      const score = explicit.match(/\b[0-5](?:\.\d+)?\b/) || text.match(/\b[0-5](?:\.\d+)?\b/);
      if (!score && /^[★☆*\s]*$/.test(text)) {
        rating.dataset.koEmptyRating = 'true';
        rating.setAttribute('aria-hidden', 'true');
      } else if (!rating.getAttribute('aria-label') && score) {
        rating.setAttribute('role', 'img');
        rating.setAttribute('aria-label', `Customer rating ${score[0]} out of 5`);
      }
    });
  }

  function rewriteSearchHeadings() {
    if (context.pageType !== 'search') return;
    const query = clean(new URLSearchParams(location.search).get('q'), 80);
    $$('main h1, main h2').forEach((heading) => {
      const text = clean(heading.textContent, 180);
      if (/^my search$/i.test(text)) heading.textContent = 'Search the Future Market';
      else if (/showing\s+\d+\s+search results/i.test(text)) {
        const count = text.match(/\d[\d,]*/)?.[0];
        heading.textContent = `${count || 'Search'} results${query ? ` for “${query}”` : ''}`;
      }
    });
  }

  function intentURL(updates) {
    const url = new URL(location.href);
    Object.entries(updates).forEach(([key, value]) => {
      if (value == null) url.searchParams.delete(key);
      else url.searchParams.set(key, value);
    });
    return `${url.pathname}${url.search}`;
  }

  function addIntentLenses() {
    if (!['collection', 'search'].includes(context.pageType) || $('[data-ko-intents]')) return;
    const bar = d.createElement('nav');
    bar.className = 'ko-intents';
    bar.dataset.koIntents = 'true';
    bar.setAttribute('aria-label', 'Quick catalog filters');
    const label = d.createElement('strong');
    label.textContent = 'Shop by intent';
    bar.appendChild(label);
    const params = new URLSearchParams(location.search);
    const lenses = [
      { label: 'In stock', key: 'filter.v.availability', value: '1' },
      { label: 'Under $25', key: 'filter.v.price.lte', value: '25' },
      { label: 'Newest', key: 'sort_by', value: 'created-descending' },
      { label: 'Best selling', key: 'sort_by', value: 'best-selling' }
    ];
    lenses.forEach((lens) => {
      const active = params.get(lens.key) === lens.value;
      const link = d.createElement('a');
      link.href = intentURL({ [lens.key]: active ? null : lens.value, page: null });
      link.textContent = lens.label;
      if (active) link.setAttribute('aria-current', 'true');
      link.addEventListener('click', () => emit('orbit_intent_filter', { intent: lens.label, active: !active }));
      bar.appendChild(link);
    });
    const explore = d.createElement('button');
    explore.type = 'button';
    explore.textContent = 'Explore smarter';
    explore.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCommand();
    });
    bar.appendChild(explore);
    if ([...params.keys()].some((key) => key.startsWith('filter.') || key === 'sort_by')) {
      const reset = d.createElement('a');
      const url = new URL(location.href);
      [...url.searchParams.keys()].forEach((key) => { if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key); });
      reset.href = `${url.pathname}${url.search}`;
      reset.textContent = 'Reset';
      bar.appendChild(reset);
    }
    const main = $('main, #MainContent, [role="main"]');
    if (main) main.prepend(bar);
  }

  function updateControlLabel(control, label) {
    if (!control) return;
    if (control instanceof HTMLInputElement) control.value = label;
    else {
      const textNodes = [...control.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE && clean(node.textContent));
      if (textNodes.length) textNodes[0].textContent = label;
      else control.textContent = label;
    }
    control.setAttribute('aria-label', label);
  }

  function productAddControl() {
    const forms = $$('form[action*="/cart/add"]');
    for (const form of forms) {
      const control = $('button[type="submit"], input[type="submit"], button[name="add"]', form);
      if (control && !control.closest('.shopify-payment-button')) return control;
    }
    return null;
  }

  function enhanceProductPage() {
    if (context.pageType !== 'product' || !decision || !context.product) return;
    const addControl = productAddControl();
    if (!addControl) return;
    const originalLabel = clean(addControl.value || addControl.textContent, 100);
    if (/^checkout\b/i.test(originalLabel)) updateControlLabel(addControl, context.product.available ? 'Add to bag' : 'Sold out');
    const product = currentProduct();
    $('[data-ko-decision-title]', decision).textContent = product?.title || context.pageTitle;
    $('[data-ko-decision-meta]', decision).textContent = `${clean(context.product.price, 40)} · ${context.product.available ? 'Available now' : 'Currently unavailable'}`;
    const add = $('[data-ko-add]', decision);
    const save = $('[data-ko-save]', decision);
    add.disabled = addControl.disabled || !context.product.available;
    add.textContent = context.product.available ? 'Add to bag' : 'Sold out';
    save.setAttribute('aria-pressed', String(isSaved(product.url)));
    save.textContent = isSaved(product.url) ? 'Saved' : 'Save';
    if (decision.dataset.koReady !== 'true') {
      decision.dataset.koReady = 'true';
      add.addEventListener('click', () => {
        if (addControl.disabled) return;
        emit('orbit_decision_add_intent', { handle: product.handle });
        addControl.click();
      });
      save.addEventListener('click', () => {
        const saved = toggleSaved(product);
        save.setAttribute('aria-pressed', String(saved));
        save.textContent = saved ? 'Saved' : 'Save';
      });
      $('[data-ko-product-ask]', decision).addEventListener('click', () => {
        emit('orbit_decision_assistant', { handle: product.handle });
        openAssistant(`Help me decide whether ${product.title} is right for me. Explain fit, tradeoffs, and anything I should confirm.`);
      });
    }
    decision.hidden = false;
  }

  function buildCartRecovery() {
    if (context.pageType !== 'cart' || $('[data-ko-cart-recovery]')) return;
    const main = $('main, #MainContent, [role="main"]');
    if (!main || !/cart is empty|your cart.*empty|shopping cart.*empty/i.test(clean(main.textContent, 4000))) return;
    const section = d.createElement('section');
    section.className = 'ko-cart-recovery';
    section.dataset.koCartRecovery = 'true';
    const eyebrow = d.createElement('span');
    eyebrow.className = 'ko-eyebrow';
    eyebrow.textContent = 'A better next step';
    const heading = d.createElement('h2');
    heading.textContent = 'Your bag is open to possibilities.';
    const copy = d.createElement('p');
    copy.textContent = 'Browse the market, return to something you saved, or let Kloudz narrow the catalog around what matters to you.';
    const actions = d.createElement('div');
    actions.className = 'ko-cart-recovery__actions';
    const browse = d.createElement('a');
    browse.href = `${collectionsRoute}/all`;
    browse.textContent = 'Explore all products';
    const search = d.createElement('a');
    search.href = searchRoute;
    search.textContent = 'Search the market';
    const ask = d.createElement('button');
    ask.type = 'button';
    ask.textContent = 'Ask Kloudz to guide me';
    ask.addEventListener('click', () => openAssistant('Help me find a product. Start by asking what matters most to me.'));
    actions.append(browse, search, ask);
    section.append(eyebrow, heading, copy, actions);
    main.appendChild(section);
    $$('[role="status"]', main).forEach((node) => {
      if (/^loading(?:\.{3})?$/i.test(clean(node.textContent))) node.hidden = true;
    });
  }

  function enhanceContactLinks(scope = d) {
    $$('footer a, footer button', scope).forEach((node) => {
      if (node.dataset.koContactChecked === 'true') return;
      node.dataset.koContactChecked = 'true';
      const text = clean(node.textContent, 160);
      const email = text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i)?.[0];
      const phone = text.match(/(?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/)?.[0];
      if (node instanceof HTMLAnchorElement) {
        if (email && !/^mailto:/i.test(node.href)) node.href = `mailto:${email}`;
        else if (phone && !/^tel:/i.test(node.href)) node.href = `tel:${phone.replace(/[^+\d]/g, '')}`;
      } else if (email || phone) {
        node.setAttribute('role', 'link');
        node.addEventListener('click', () => { location.href = email ? `mailto:${email}` : `tel:${phone.replace(/[^+\d]/g, '')}`; });
      }
    });
  }

  function enhance(scope = d) {
    repairProductMedia(scope);
    repairCompareControls(scope);
    repairRatings(scope);
    enhanceContactLinks(scope);
    rewriteSearchHeadings();
    addIntentLenses();
    enhanceProductPage();
    buildCartRecovery();
  }

  function updateNetwork() {
    if (!network) return;
    const online = navigator.onLine;
    network.textContent = online ? 'Online' : 'Offline · browsing remains available';
    network.dataset.koOffline = String(!online);
    announce(online ? 'Connection restored.' : 'You are offline. Browsing may show cached content; no action will be taken.');
  }

  $$('[data-ko-command-open]').forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    openCommand();
  }));
  $$('[data-ko-command-close]', command).forEach((button) => button.addEventListener('click', () => closeCommand()));
  $$('[data-ko-ask]').forEach((button) => button.addEventListener('click', () => openAssistant(button.dataset.koAsk)));
  $('[data-ko-command-form]').addEventListener('submit', (event) => {
    event.preventDefault();
    const query = clean(commandInput.value, 120);
    if (!query) return;
    emit('orbit_search_submit', { queryLength: query.length });
    location.href = `${searchRoute}?q=${encodeURIComponent(query)}`;
  });
  commandInput.addEventListener('input', () => {
    w.clearTimeout(searchTimer);
    searchTimer = w.setTimeout(() => suggest(commandInput.value), 180);
  });

  d.addEventListener('keydown', (event) => {
    if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      command.hidden ? openCommand() : closeCommand();
      return;
    }
    if (event.key === 'Escape' && !command.hidden) {
      event.preventDefault();
      closeCommand();
      return;
    }
    if (event.key === 'Tab' && !command.hidden) {
      const focusable = focusableInCommand();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && d.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && d.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  d.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href*="/products/"]');
    if (!link) return;
    const handle = String(link.getAttribute('href') || '').split('/products/')[1]?.split(/[?#/]/)[0] || '';
    emit('orbit_product_open', { handle: clean(handle, 90) });
  });

  w.addEventListener('online', updateNetwork);
  w.addEventListener('offline', updateNetwork);
  w.addEventListener('storage', (event) => { if (event.key === SAVED_KEY) renderSaved(); });
  d.addEventListener('visitorConsentCollected', renderSaved);
  w.addEventListener('visitorConsentCollected', renderSaved);

  const OrbitChannel = w.BroadcastChannel;
  const orbitChannel = OrbitChannel ? new OrbitChannel('kloudz-orbit') : null;
  if (orbitChannel) orbitChannel.addEventListener('message', (event) => {
    if (event.data?.type === 'saved') renderSaved();
  });

  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
    w.clearTimeout(observerTimer);
    observerTimer = w.setTimeout(() => enhance(d), 120);
  });
  observer.observe(d.body, { childList: true, subtree: true });

  renderSaved();
  updateNetwork();
  enhance(d);
  root.dataset.koStage = 'ready';
  w.KloudzOrbit = Object.freeze({ version: VERSION, open: openCommand, close: closeCommand, saved: readSaved });
})();
